export const EMPRESA_STATUS_LABELS: Record<string, string> = {
  PROSPECT: 'Prospecto',
  CLIENTE_ATIVO: 'Cliente ativo',
  CHURN: 'Churn',
}

/** Rótulos de status antigo, só para exibir registro já gravado. */
export const EMPRESA_STATUS_LEGACY_LABELS: Record<string, string> = {
  ativo: 'Ativo',
  inativo: 'Inativo',
  prospecto: 'Prospecto',
  churned: 'Churned',
}

export const EMPRESAS_PAGE_SIZE = 10
